// Moteur de prix partagé REVDECO — fiche produit, configurateur, devis.
// Dépend de window.REVDECO_PRINTPRICES (printprices.js) pour les barèmes de marquage.
(function(){
  var VAT = 1.20;
  // Paliers de quantité + remise volume (produit) — style Wordans. Politique REVDECO, ajustable ici.
  var TIERS_Q = [
    { min:1,   max:7,      label:'1-7',     disc:0    },
    { min:8,   max:35,     label:'8-35',    disc:0.05 },
    { min:36,  max:71,     label:'36-71',   disc:0.10 },
    { min:72,  max:143,    label:'72-143',  disc:0.15 },
    { min:144, max:287,    label:'144-287', disc:0.20 },
    { min:288, max:999999, label:'288+',    disc:0.25 }
  ];
  function tierIndex(q){ for(var i=0;i<TIERS_Q.length;i++){ if(q>=TIERS_Q[i].min && q<=TIERS_Q[i].max) return i; } return 0; }
  function unitAtTier(baseHT, ti){ return Math.round(baseHT*(1-TIERS_Q[ti].disc)*100)/100; }

  function qtyScale(scales, qty){ var pick=scales[0]; for(var i=0;i<scales.length;i++){ if(qty>=scales[i][0]) pick=scales[i]; } return pick; }
  // aire d'une position de marquage en cm² (les dimensions midOcean sont en mm, parfois cm)
  function areaOf(pos){
    var w=parseFloat(pos.w)||0, h=parseFloat(pos.h)||0;
    var mm2 = (String(pos.unit||'mm').toLowerCase().indexOf('cm')===0) ? w*h*100 : w*h;
    return mm2/100;
  }
  function markUnit(techId, qty, areaCm2){
    var PP = window.REVDECO_PRINTPRICES || {};
    var t = PP[techId]; if(!t) return null;
    var rng = t.ranges[0];
    for(var i=0;i<t.ranges.length;i++){ var r=t.ranges[i]; if(areaCm2>=r.from && (r.to===0||areaCm2<r.to)){ rng=r; break; } }
    if(!rng) rng=t.ranges[t.ranges.length-1];
    var sc=qtyScale(rng.scales, qty);
    return { perUnit: sc[1], setup: t.setup };
  }
  // marquage standard = technique la moins chère de la 1re position, à la quantité donnée.
  // setup = FRAIS DE CALAGE : coût UNIQUE par commande (jamais par pièce).
  function stdMarking(d, qty){
    var pos = d && d.print && d.print.positions && d.print.positions[0];
    if(!pos) return null;
    var area = areaOf(pos);
    var best=null;
    for(var i=0;i<pos.techniques.length;i++){
      var tq = markUnit(pos.techniques[i].id, qty, area);
      if(!tq) continue;
      var amortized = tq.perUnit + tq.setup/qty;
      if(!best || amortized<best.a) best={ name:pos.techniques[i].name, perUnit:tq.perUnit, setup:tq.setup, a:amortized };
    }
    return best;
  }
  // marquage choisi dans le configurateur (cfg = {pos, tech} sauvegardé en localStorage).
  // Renvoie null si la config ne correspond plus au produit → l'appelant retombe sur stdMarking.
  function cfgMarking(d, cfg, qty){
    if(!d || !cfg || !d.print || !d.print.positions) return null;
    var pos=null;
    for(var i=0;i<d.print.positions.length;i++){ if(d.print.positions[i].id===cfg.pos){ pos=d.print.positions[i]; break; } }
    if(!pos) return null;
    var tech=null;
    for(var j=0;j<pos.techniques.length;j++){ if(pos.techniques[j].id===cfg.tech){ tech=pos.techniques[j]; break; } }
    if(!tech) return null;
    var tq = markUnit(tech.id, qty, areaOf(pos));
    if(!tq) return null;
    return { name:tech.name, pos:pos.id, perUnit:tq.perUnit, setup:tq.setup };
  }

  window.REVDECO_PRICING = {
    VAT:VAT, TIERS_Q:TIERS_Q, tierIndex:tierIndex, unitAtTier:unitAtTier,
    qtyScale:qtyScale, areaOf:areaOf, markUnit:markUnit, stdMarking:stdMarking, cfgMarking:cfgMarking
  };
})();

// ===== Dégressivité PRODUIT VIERGE (politique REVDECO validée 2026-07-28) =====
// S'applique au produit (vierge ou support d'un marquage) via remises à seuil de quantité.
(function(){
  var P = window.REVDECO_PRICING || {};
  P.TIERS_V = [
    { min: 1,   label: '1-9',     disc: 0,    code: null },
    { min: 10,  label: '10-29',   disc: 0.08, code: 'REVDECO10' },
    { min: 30,  label: '30-59',   disc: 0.16, code: 'REVDECO30' },
    { min: 60,  label: '60-119',  disc: 0.21, code: 'REVDECO60' },
    { min: 120, label: '120-249', disc: 0.26, code: 'REVDECO120' },
    { min: 250, label: '250+',    disc: 0.32, code: 'REVDECO250' }
  ];
  P.vTier = function (qty) {
    var t = P.TIERS_V[0];
    for (var i = 0; i < P.TIERS_V.length; i++) { if (qty >= P.TIERS_V[i].min) t = P.TIERS_V[i]; }
    return t;
  };
  window.REVDECO_PRICING = P;
})();

// ===== Prestation ATELIER REVDECO — GRILLE DTF VALIDÉE PAR DENIS le 2026-09-23 =====
// Construite sur le comparatif TH4/Wordans (relevé du 23/09) : produit fini −4 à −7 %
// sous les deux concurrents sur torse/dos/poitrine ; manches protégées (pose délicate,
// jamais l'appât du devis). ⚠️ Même grille dans connecteur/create-perso-product.js.
(function(){
  var P = window.REVDECO_PRICING || {};
  // €/pièce par palier (alignés sur TIERS_V) : [1-9, 10-29, 30-59, 60-119, 120-249, 250+]
  P.ATELIER_PRINT = {
    large:  [9.90, 4.90, 2.45, 1.55, 1.35, 1.30], // Torse / Dos (pose facile, grand format)
    small:  [6.50, 1.80, 1.20, 0.85, 0.75, 0.65], // Poitrine (petit logo, pose facile)
    sleeve: [7.50, 2.50, 1.80, 1.40, 1.25, 1.10]  // Manches / nuque (petit mais pose DIFFICILE)
  };
  // classe de POSE par emplacement — c'est la pose qui fait le prix, pas la surface
  P.zoneOf = function (pos) {
    var id = String((pos && pos.id) || '').toUpperCase();
    if (/ARM|SLEEVE|MANCHE|NECK|NUQUE/.test(id)) return 'sleeve';
    if (/CHEST|POITRINE/.test(id)) return 'small';
    if (/FRONT|BACK|TORSE|DOS/.test(id)) return 'large';
    return (P.areaOf(pos) >= 300) ? 'large' : 'small'; // repli : classement par surface
  };
  // ===== BRODERIE (sous-traitée midOcean, technique E) — VALIDÉE PAR DENIS le 2026-09-29 =====
  // Coût midOcean = prix/pièce selon l'aire + CALAGE 40 € par emplacement et par commande.
  // Décisions : ① calage refacturé tel quel en « mise en place » (ligne unique au panier,
  // par emplacement brodé) ; ② grande broderie PLAFONNÉE à 20 × 20 cm (au-delà, le coût
  // midOcean d'un dos 25×25 dépasse la grille). Marge ≥ 30 % à tous les paliers.
  P.ATELIER_BRODERIE = {
    bro_large: [24.90, 18.90, 14.90, 12.90, 11.90, 10.90], // dos / torse, jusqu'à 20 × 20 cm
    bro_small: [12.90, 9.90, 7.90, 6.90, 6.40, 5.90]       // poitrine, manches (≤ ~12 × 12 cm)
  };
  P.BRODERIE_SETUP = 40;    // € HT par emplacement brodé, une fois par commande
  P.BRODERIE_MAX_MM = 200;  // côté maxi d'une broderie
  P.broZoneOf = function (pos) {
    var w = Math.min(parseFloat(pos && pos.w) || 0, P.BRODERIE_MAX_MM), h = Math.min(parseFloat(pos && pos.h) || 0, P.BRODERIE_MAX_MM);
    if (String((pos && pos.unit) || 'mm').toLowerCase().indexOf('cm') === 0) { w *= 10; h *= 10; }
    var id = String((pos && pos.id) || '').toUpperCase();
    if (/ARM|SLEEVE|MANCHE|CHEST|POITRINE/.test(id)) return 'bro_small';
    return (w * h / 100 > 150) ? 'bro_large' : 'bro_small';
  };
  // mode : 'broderie' → grille broderie ; sinon grille DTF atelier
  P.atelierZone = function (pos, mode) { return mode === 'broderie' ? P.broZoneOf(pos) : P.zoneOf(pos); };
  P.atelierUnit = function (pos, qty, mode) {
    var zone = P.atelierZone(pos, mode);
    var grid = P.ATELIER_BRODERIE[zone] || P.ATELIER_PRINT[zone];
    var ix = 0;
    for (var i = 0; i < P.TIERS_V.length; i++) { if (qty >= P.TIERS_V[i].min) ix = i; }
    return grid[Math.min(ix, grid.length - 1)];
  };
  window.REVDECO_PRICING = P;
})();
